import { Color } from 'pixi.js';
import { Signal } from '@/models/data/Signal';

/** Compute 4-bit state index from the 4 side signals (T=8, R=4, B=2, L=1). */
export function computeMIStateIndex(meta: { inputs: Record<string, Signal | null>; outputs: Record<string, Signal | null> }): number {
  const sides = [
    { key: 'top', bit: 8 },
    { key: 'right', bit: 4 },
    { key: 'bottom', bit: 2 },
    { key: 'left', bit: 1 },
  ];
  let index = 0;
  for (const { key, bit } of sides) {
    const inp = (meta.inputs as Record<string, Signal>)[key];
    const out = (meta.outputs as Record<string, Signal>)[key];
    if (inp === Signal.HIGH || out === Signal.HIGH) {
      index |= bit;
    }
  }
  return index;
}

/** Interpolate between two hex colors. t in [0, 1]. */
export function interpolateColor(from: string, to: string, t: number): string {
  const fromColor = new Color(from);
  const toColor = new Color(to);

  const fr = fromColor.red;
  const fg = fromColor.green;
  const fb = fromColor.blue;

  const tr = toColor.red;
  const tg = toColor.green;
  const tb = toColor.blue;

  const r = fr + (tr - fr) * t;
  const g = fg + (tg - fg) * t;
  const b = fb + (tb - fb) * t;

  return new Color({ r: r * 255, g: g * 255, b: b * 255 }).toHex();
}

/** Convert persisted Pixi hex colors to the CSS format used by color pickers. */
export function normalizeHexColor(value: string): string | null {
  const match = /^(?:#|0x)([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(value.trim());
  if (!match) return null;
  const hex = match[1].toLowerCase();
  return '#' + (hex.length === 3 ? [...hex].map(c => c + c).join('') : hex);
}
